import Floorplan from '@sandj-packages/sandj-floorplan';

class Plan {
    static init() {
        document.querySelectorAll('.js-plan').forEach((plan) => {
            const planitem = new Floorplan(plan);
            planitem.init();
        });

        // CUSTOM TO DISPLAY TABS PLAN
        const tabsPlan = document.querySelector('.js-plan-tabs');
        if (!tabsPlan) {
            return;
        }
        tabsPlan.querySelectorAll('.js-plan-tab').forEach((tab) => {
            tab.addEventListener('click', () => {
                tabsPlan.querySelectorAll('.js-plan-tab').forEach((item) => {
                    item.classList.remove('active');
                });
                tab.classList.add('active');
                tabsPlan.querySelectorAll('.js-plan-tabs-blocks').forEach((blocks) => {
                    blocks.classList.remove('active');
                });
                const block = document.querySelector(`#block-${tab.dataset.tab}`);
                if (block) {
                    block.classList.add('active');
                }
            });
        });
        // Show first tab by default
        const firstTab = tabsPlan.querySelector('.js-plan-tab');
        if (firstTab) {
            firstTab.click();
        }
    }
}

export default Plan;
